// Chapter 3 of the detective game: "결합" (see Detective.js).
// Everything the player reads lives here; Detective.js only knows how to play it.

const n = (text) => ({ who: 'narr', text });
const me = (text) => ({ who: 'me', text });
const say = (who, text) => ({ who, text });

export const META = {
  id: 'ch3',
  number: 3,
  hanja: '結合',
  name: '결합',
  subtitle: '모항 펜션 사건',
  tagline: '한번 붙으면 놓지 않는 것이 있다.',
  saveKey: 'detective_progress_ch3',
  startLoc: 'boiler',
  // The in-game clock runs on clues found, in minutes from Sunday midnight: two hours a clue,
  // Sunday 10:00 with none and Wednesday 08:00 with all 35. The EVENTS thresholds are set
  // against it, so adding or removing a clue means revisiting them.
  clock: { start: 600, end: 4800, days: ['일요일', '월요일', '화요일', '수요일'], limit: '기한 수요일 09:00' },
};

export const SPEAKERS = {
  me: { name: '서지안', title: '형사', tone: 'me' },
  eunho: { name: '윤은호', title: '국과수 연구관', tone: 'blue' },
  kang: { name: '강 팀장', title: '강력2팀장', tone: 'gray' },
  seoyeon: { name: '임서연', title: '도정훈의 아내', tone: 'rose' },
  dayoung: { name: '임다영', title: '임서연의 딸', tone: 'violet' },
  hyunwoo: { name: '도현우', title: '도정훈의 아들', tone: 'green' },
  bang: { name: '방덕수', title: '펜션 주인', tone: 'orange' },
  doc: { name: '당직의', title: '응급의학과', tone: 'amber' },
  nurse: { name: '간호사', title: '관찰 병동', tone: 'amber' },
  lawyer: { name: '고문 변호사', title: '정훈건설 법률 고문', tone: 'gray' },
  caller: { name: '제보 전화', title: '녹음', tone: 'gray' },
};

export const CLUES = {
  flue: {
    name: '풀린 연통',
    kind: '물증',
    text: '보일러 연통 이음부의 나사 구멍 두 개에 나사가 없다. 구멍 둘레에 드라이버가 미끄러진 새 자국. 틈을 메운 실리콘은 칼로 잘렸다.',
  },
  inspection: {
    name: '지난달 점검 사진',
    kind: '물증',
    text: '11월 14일 가스 정기 점검. 해송동 연통 이음부에 나사 두 개가 박혀 있고 실리콘이 빈틈없이 발라져 있다.',
  },
  alarm: {
    name: '뽑힌 경보기와 충전기',
    kind: '물증',
    text: '거실의 일산화탄소 경보기가 뽑혀 소파 밑에 있었다. 그 콘센트에는 휴대폰 충전기가 꽂혀 있었다. 거기 물려 있던 휴대폰은 과학수사팀이 거둬 갔다.',
  },
  phone: {
    name: '충전되던 휴대폰',
    kind: '물증',
    text: '구급대가 도착했을 때 경보기 자리의 콘센트에서 충전되고 있던 휴대폰. 통신사에 물어 확인한 가입자는 도현우다.',
  },
  thermostat: {
    name: '온도조절기 기록',
    kind: '물증',
    text: '평소 설정은 22도 예약 운전. 토요일 23시 40분에 30도 연속 운전으로 바뀌었다. 보일러는 아침까지 쉬지 않고 돌았다.',
  },
  layout: {
    name: '집의 구조',
    kind: '물증',
    text: '보일러실 옆 계단이 다락으로 이어진다. 안방과 작은방은 문이 닫혀 있었다. 바닥 난방이라 공기를 섞는 바람이 없다.',
  },
  butts: {
    name: '담배꽁초 세 개',
    kind: '물증',
    text: '보일러실 문 앞에 같은 상표의 꽁초 셋. 버린 지 하루가 안 됐다. 가족 중 담배를 피우는 사람은 한 명뿐이라고 했다.',
  },
  driver: {
    name: '관리동의 드라이버',
    kind: '물증',
    text: '관리동 공구함의 십자드라이버. 연통 나사에 크기가 맞고, 날 끝에 새 쇳가루가 묻어 있다. 방덕수는 보일러실을 언제든 드나든다.',
  },
  driverTest: {
    name: '드라이버를 맞춰 본 결과',
    kind: '증언',
    text: '윤은호의 말. 관리동 드라이버는 날 한쪽 귀가 떨어져 나갔는데, 연통에 남은 자국에는 그 흔적이 없다. 날에 묻은 쇳가루도 연통의 것이 아니다. 연통을 푼 것은 다른 드라이버다.',
  },
  breakfast: {
    name: '8시 조식 예약',
    kind: '물증',
    text: '예약 장부의 메모. 「일요일 아침 8시 미역국 조식 4인. 꼭 8시 정각에. 대답 없으면 열고 들어오라고 함.」 예약자 칸의 이름은 도정훈이다.',
  },
  breakfastAsk: {
    name: '8시를 다짐받은 사람',
    kind: '증언',
    text: '방덕수의 말. 예약 전화를 건 사람은 도현우다. 「8시 정각에, 대답 없으면 열고 들어오세요」라고 두 번 다짐을 받았다.',
  },
  watch: {
    name: '피해자의 스마트워치',
    kind: '물증',
    text: '수면 시작 22시 52분. 이후 깬 기록이 없다. 04시 31분에 심박이 끊겼다.',
  },
  cohb: {
    name: '응급실 혈액검사',
    kind: '물증',
    text: '도착 직후의 일산화탄소 수치. 도정훈 58%(사후), 임서연 34%, 임다영 29%, 도현우 9%.',
  },
  oximeter: {
    name: '정상으로 나온 산소포화도',
    kind: '물증',
    text: '구급대의 손가락 측정기는 세 사람 모두 97~98%였다. 그 기계는 산소가 붙은 피와 일산화탄소가 붙은 피를 구분하지 못한다.',
  },
  ribs: {
    name: '임서연의 진료 기록',
    kind: '물증',
    text: '올해 10월 좌측 갈비뼈 두 개 골절. 본인 진술은 「계단에서 넘어짐」. 과거에 부러졌다 붙은 흔적이 여럿 있다.',
  },
  retest: {
    name: '다음 날 재검',
    kind: '물증',
    text: '월요일 아침 수치. 임서연 2%, 임다영 1%, 도현우 8%. 도현우는 병원 주차장에서 하루 한 갑쯤 담배를 피운다.',
  },
  fingerprints: {
    name: '지문 감식 결과',
    kind: '물증',
    text: '온도조절기 버튼에서 임서연의 지문. 경보기 전원 플러그에서 임다영의 지문.',
  },
  insurance: {
    name: '사망보험',
    kind: '물증',
    text: '도정훈이 죽으면 5억이 나오는 보험. 돈을 받는 사람은 임서연. 2년 전 가입.',
  },
  calls112: {
    name: '112 신고 이력',
    kind: '물증',
    text: '도정훈의 집에서 3년간 세 건. 마지막은 딸의 신고 「엄마가 맞고 있다」. 세 건 모두 「현장 종결. 피해자가 처벌을 원하지 않음」.',
  },
  tip: {
    name: '익명 제보 전화',
    kind: '물증',
    text: '일요일 14시 20분, 이름을 대지 않은 남자의 전화. 그 집 여자는 맞고 살았고, 남편 앞으로 보험을 들어 놨고, 어젯밤 보일러를 올린 것도 그 여자라고 했다. 발신지는 서해의료원 로비 공중전화.',
  },
  payphone: {
    name: '로비 CCTV',
    kind: '물증',
    text: '일요일 14시 20분, 병원 로비 공중전화 앞에 환자복을 입고 링거 걸이를 끈 남자. 얼굴이 찍혔다. 도현우다.',
  },
  sale: {
    name: '피해자의 서류 가방',
    kind: '물증',
    text: '12월 12일 회사 매각 계약, 12월 16일 유언 공증 예약, 임다영을 딸로 올리는 입양 신고서. 신고서에는 임다영 본인의 서명만 비어 있다. 전부 며칠 뒤의 일이었다.',
  },
  lawyer: {
    name: '변호사의 상담 일지',
    kind: '물증',
    text: '지난달 도현우가 혼자 찾아와 걱정하듯 물었다. 새어머니가 아버지를 해쳐서 유죄가 되면 상속은 어떻게 되느냐고. 변호사는 「새어머니 몫까지 전부 아드님에게 간다」고 답해 줬다.',
  },
  carlog: {
    name: '주차장의 밤',
    kind: '물증',
    text: '해변 공영주차장의 시청 방범 카메라. 00시 12분에 도현우가 자기 차에 탄다. 00시 14분부터 07시 26분까지 배기구의 김이 끊기지 않는다. 07시 26분에 내려서 펜션 쪽으로 걸어간다.',
  },
  experiment: {
    name: '재현 실험',
    kind: '물증',
    text: '같은 조건에서 방마다 농도를 쟀다. 다락이 가장 높고, 1층의 안방과 작은방은 그 6분의 1로 서로 같다. 1층 어느 방에서든 여덟 시간을 자면 피 속 수치가 30% 안팎이 된다.',
  },
  ownerGrudge: {
    name: '펜션 주인의 소송',
    kind: '증언',
    text: '방덕수의 말. 도정훈의 회사가 지은 별채의 하자를 3년째 고쳐 주지 않아 소송 중이다.',
  },
  hyunwooStory: {
    name: '도현우의 진술',
    kind: '증언',
    text: '밤 11시쯤 작은방에 들어가 잤고, 아침에 펜션 주인이 깨워서 눈을 떴다. 머리가 깨질 듯 아팠다.',
  },
  heatAsk: {
    name: '보일러를 올린 이유',
    kind: '증언',
    text: '임서연의 말. 처음에는 남편이 춥다고 해서 올렸다고 했다. 시계 기록을 보여 주자 말을 바로잡았다. 남편에게 직접 들은 것이 아니라, 도현우가 「아버지가 위에서 춥다고 하시네요. 보일러 좀 세게 올려 주세요」라고 전했다는 것이다.',
  },
  chargeAsk: {
    name: '경보기를 뽑은 이유',
    kind: '증언',
    text: '임다영의 말. 도현우가 「충전기 좀 꽂게 그거 뽑아 줄래」라고 해서 뽑았다. 경보기인 줄 몰랐다.',
  },
  dinner: {
    name: '생일상에서 나온 말',
    kind: '증언',
    text: '임다영의 말. 도정훈은 초를 끈 뒤 다음 주에 회사를 판다고 알렸고, 아들에게 「넌 네 힘으로 살아라」 했다. 도현우는 웃으며 대답했지만 케이크에는 손을 대지 않았다.',
  },
  confession: {
    name: '임서연의 자백',
    kind: '증언',
    text: '저녁 9시쯤 관리동에서 열쇠를 빌려 보일러실에 들어가 연통을 손으로 잡아 뺐다고 했다.',
  },
  halfLife: {
    name: '붙은 것이 떨어지는 시간',
    kind: '증언',
    text: '윤은호의 설명. 일산화탄소 수치는 맑은 공기에서 4~6시간마다 절반이 된다. 흡연자는 평소에도 3~10%가 나와서 10%를 넘어야 중독으로 본다.',
  },
  parents: {
    name: '윤은호의 부모',
    kind: '기억',
    text: '윤은호가 고3 때 물류센터 화재로 돌아가셨다. 스프링클러가 잠겨 있었다. 그래서 윤은호는 대답하는 사람이 되기로 했다.',
  },
  nameGame: {
    name: '원소로 쓴 이름',
    kind: '기억',
    text: '윤은호는 원소 기호 여섯 개로 써진다. Y, U, N, Eu, N, Ho. 아버지가 화학 선생님이었다. 내 이름은 써지지 않는다. 주기율표에 J가 없어서.',
  },
  brother: {
    name: '윤은호의 동생',
    kind: '기억',
    text: '과학관 옥상에서 본 문자. 「형. 올해도 납골당은 나 혼자 다녀왔어.」 보낸 사람은 동생 시호. 윤은호는 답장을 쓰다 지웠다.',
  },
};

export const INTRO = [
  n("12월 8일 일요일, 오전 열 시. 서해시 모항 해변의 펜션 '파도소리'."),
  n('박 반장이 떠난 지 아홉 달. 창가 자리에는 새 팀장이 앉았고, 믹스커피 상자는 내 서랍으로 옮겨 왔다.'),
  n('한 시간 반 전, 당직이던 나에게 강 팀장이 전화를 걸었다.'),
  say('kang', '서 경위. 모항 펜션에서 일가족 넷이 쓰러졌어. 한 명 사망. 보일러 연통이 빠졌대. 6년 전 강릉이랑 판박이야.'),
  say('kang', '사고면 오늘 안에 정리하고, 사건이면 제일 유력한 사람부터 잡아. 난 복잡한 거 안 좋아해.'),
  n('강 팀장은 나쁜 사람이 아니다. 다만 가장 단순한 답을 가장 먼저 고르는 사람이다.'),
  n("숨진 사람은 도정훈, 59세. 지역 건설사 대표. 생일을 맞아 가족과 복층 독채 '해송동'에 묵었다."),
  n('도정훈은 다락에서 혼자 자다 숨졌다. 1층에서 자던 아내와 의붓딸, 아들은 병원으로 실려 갔다.'),
  n('해송동 뒤편 보일러실 앞에 누군가 쪼그려 앉아 있었다. 익숙한 뒷모습이다. 이번에는 손 떼고 일어나라고 하지 않았다.'),
  me('…다음에는 아무도 다치지 않은 자리에서 보자고 하지 않았어요?'),
  say('eunho', '불난 자리는 피했습니다. 가스 샌 자리로 왔으니까요. …반만 지켰네요.'),
  n('윤은호는 일어나서 장갑을 벗고, 벗은 손을 어디 둘지 몰라 다시 꼈다. 아홉 달 만이다. 나도 연락하지 않았고, 윤은호도 하지 않았다.'),
  say('eunho', '잘 지내셨어요. …아, 이런 데서 할 인사는 아닌가.'),
  say('eunho', '연통부터 보시죠. 형사님이 좋아하실 만한 게 있습니다.'),
  say('sys', '펜션과 병원을 조사하고, 사람들을 심문하고, 단서를 모으세요. 준비가 되면 [추리하기]로 강 팀장에게 보고합니다.'),
];

export const LOCATIONS = [
  {
    id: 'house',
    name: '해송동 1층',
    desc: '복층 독채의 1층. 거실 겸 주방, 안방, 작은방. 창문은 전부 열어 환기를 마쳤다. 식탁에는 어젯밤 생일상이 그대로다. 케이크에 꽂힌 초가 쉰아홉 개는 아니고, 큰 초 다섯에 작은 초 아홉이다.',
    hotspots: [
      {
        id: 'alarm',
        label: '거실의 경보기를 본다',
        variants: [
          {
            lines: [
              n('거실 벽 콘센트 옆에 하얀 받침대만 붙어 있다. 일산화탄소 경보기 자리다. 본체는 플러그가 뽑힌 채 소파 밑에 들어가 있었다.'),
              n('경보기가 꽂혀 있어야 할 콘센트에는 휴대폰 충전기가 꽂혀 있다. 줄 끝은 비어 있다.'),
              n('구급대가 왔을 때는 그 끝에 휴대폰 한 대가 물려 있었다고 한다. 누구 것인지는 아직 모른다. 화면이 잠겨 있어서 과학수사팀이 거둬 갔다.'),
            ],
            gives: ['alarm'],
          },
        ],
      },
      {
        id: 'thermostat',
        label: '온도조절기를 본다',
        variants: [
          {
            lines: [
              n('거실 벽의 보일러 조절기. 작은 화면에 설정 기록이 남는다.'),
              n('평소 설정은 「22도 예약 운전」. 토요일 밤 23시 40분, 누군가 「30도 연속 운전」으로 바꿨다.'),
              n('그 뒤로 보일러는 아침까지 한 번도 쉬지 않고 돌았다. 연통이 빠진 보일러가.'),
            ],
            gives: ['thermostat'],
          },
        ],
      },
      {
        id: 'rooms',
        label: '방의 배치를 본다',
        variants: [
          {
            lines: [
              n('안방에는 요가 두 채. 임서연과 임다영이 여기서 잤다. 작은방에는 요 한 채. 도현우의 자리다. 두 방 모두 발견 당시 문이 닫혀 있었다.'),
              n('다락으로 가는 계단은 뒷문 바로 옆에 있다. 그 뒷문 너머가 보일러실이다.'),
              n('바닥을 데우는 난방이라 공기를 섞는 바람이 없다. 새어 들어온 더운 배기가스는 계단을 타고 위로 올라갔을 것이다.'),
            ],
            gives: ['layout'],
          },
        ],
      },
      {
        id: 'table',
        label: '식탁을 본다',
        variants: [
          {
            lines: [
              n('소주병 셋, 맥주병 넷. 도정훈은 술을 많이 했다고 했다.'),
              n('케이크는 네 조각으로 잘렸다. 세 접시는 비었고, 한 접시의 조각은 포크 자국 없이 그대로다. 누구의 접시인지는 식탁만 봐서는 알 수 없다.'),
              n('재떨이는 없다. 이 가족은 담배를 밖에 나가서 피우는 것이 규칙이었다고 했다.'),
            ],
            flag: 'cake',
          },
        ],
      },
    ],
  },
  {
    id: 'loft',
    name: '다락',
    desc: '계단을 오르면 지붕 밑 침실이다. 천장이 낮아 허리를 굽혀야 한다. 문이 없어서 계단 구멍이 그대로 뚫려 있다. 도정훈은 여기서 혼자 잤다. 코를 심하게 골아서 늘 그랬다고 했다.',
    hotspots: [
      {
        id: 'bed',
        label: '침대를 본다',
        variants: [
          {
            lines: [
              n('이불은 가지런하다. 몸부림친 흔적이 없다. 도정훈은 잠든 채로, 한 번도 깨지 못하고 숨이 멎었다.'),
              n('응급실에서 처음 본 의사는 고개를 갸웃했다고 한다. 가스 중독이면 흔히 보인다는 선홍색 반점이 없었기 때문이다.'),
              n('병원에서 피를 뽑아 보고서야 사인이 분명해졌다.'),
            ],
          },
        ],
      },
      {
        id: 'watch',
        label: '도정훈의 스마트워치 기록을 본다',
        variants: [
          {
            lines: [
              n('도정훈은 시계를 찬 채 잤다. 유족의 동의를 받아 기록을 열었다.'),
              n('「수면 시작 22:52」. 그 뒤로 뒤척임 없이 깊은 잠. 심박수는 새벽 3시부터 빨라지다가 불규칙해진다.'),
              n('「04:31 심박 감지 안 됨」.'),
              n('기계의 오차는 있을 것이다. 그래도 큰 그림은 분명하다. 도정훈은 밤 11시가 되기 전에 잠들어서, 한 번도 깨지 않고, 새벽 4시 반에 죽었다.'),
            ],
            gives: ['watch'],
          },
        ],
      },
    ],
  },
  {
    id: 'boiler',
    name: '보일러실',
    desc: '해송동 뒷문 밖의 다용도실. 가스보일러 한 대와 세탁기가 있다. 문에는 자물쇠가 없어서 손잡이만 돌리면 열린다. 윤은호가 조명을 세워 놓고 연통 아래에 쪼그려 앉아 있다.',
    hotspots: [
      {
        id: 'flue',
        label: '연통을 본다',
        variants: [
          {
            lines: [
              n('보일러 위에서 벽으로 나가는 은색 배기통. 보일러와 만나는 이음부가 손가락 두 마디만큼 빠져 있다.'),
              say('eunho', '강릉 사고는 고정을 제대로 안 한 연통이 진동으로 조금씩 빠진 겁니다. 그래서 다들 이것도 그렇게 보죠.'),
              say('eunho', '그런데 여기 보세요. 이음부를 조이는 띠에 나사 구멍이 두 개 있습니다. 나사는 없고요. 구멍 둘레에 드라이버가 미끄러진 자국이 새로 났어요.'),
              say('eunho', '틈을 메운 내열 실리콘도 찢어진 게 아니라 잘렸습니다. 단면이 깨끗해요. 칼입니다.'),
              n('나사 두 개를 풀고, 실리콘을 자르고, 연통을 잡아 뺐다. 저절로 빠진 것이 아니다.'),
              n('받아 적고 나니 둘 다 말이 없어졌다.'),
              me('…연락할 줄 알았어요.'),
              say('eunho', '저도요. …아, 그러니까, 형사님이 하실 줄 알았다는 게 아니라. 제가 할 줄 알았습니다. 저도.'),
              n('윤은호는 연통을 한 번 더 들여다봤다. 이미 다 본 연통을.'),
            ],
            gives: ['flue'],
          },
        ],
      },
      {
        id: 'ground',
        label: '문 앞 바닥을 본다',
        variants: [
          {
            lines: [
              n('보일러실 문 앞 자갈 위에 담배꽁초가 세 개. 같은 상표다. 종이가 바래지 않았고 필터도 눌린 모양 그대로다. 버린 지 하루가 안 됐다.'),
              n('뒷문을 나서면 바로 닿는 자리다. 가족 중 담배를 피우는 사람은 한 명뿐이라고 했다.'),
            ],
            gives: ['butts'],
          },
        ],
      },
    ],
  },
  {
    id: 'lodge',
    name: '관리동',
    desc: '펜션 입구의 관리동. 주인 방덕수가 석유난로 옆에서 박하사탕을 깨물고 있다. 벽에는 독채 네 동의 열쇠와 점검표 철이 걸려 있고, 책상 밑에는 철제 공구함이 놓여 있다.',
    hotspots: [
      {
        id: 'photos',
        label: '보일러 점검 기록을 본다',
        variants: [
          {
            lines: [
              n('벽의 점검표 철. 지난달 14일, 가스 공급업체의 정기 점검.'),
              n('점검원이 찍어 붙인 사진이 있다. 해송동 보일러의 연통 이음부. 띠에 나사 두 개가 박혀 있고, 실리콘이 빈틈없이 발라져 있다.'),
              n('한 달 전에는 멀쩡했다.'),
            ],
            gives: ['inspection'],
          },
        ],
      },
      {
        id: 'toolbox',
        label: '공구함을 본다',
        variants: [
          {
            lines: [
              n('책상 밑의 철제 공구함. 다른 공구에는 먼지가 앉았는데, 맨 위의 십자드라이버 한 자루만 깨끗하다.'),
              n('날 끝에 은빛 쇳가루가 묻어 있다. 쓴 지 얼마 안 됐다. 연통 띠의 나사에 맞는 크기다.'),
              n('보일러실 문에는 자물쇠가 없다. 이 펜션에서 그 문을 가장 자주 여는 사람은 주인 방덕수다.'),
            ],
            gives: ['driver'],
          },
        ],
      },
      {
        id: 'booking',
        label: '예약 장부를 본다',
        variants: [
          {
            lines: [
              n('해송동의 예약자 칸에는 도정훈의 이름이 적혀 있다. 메모란에 주인의 글씨가 있다.'),
              n('「생신. 일요일 아침 8시 미역국 조식 4인. 꼭 8시 정각에. 대답 없으면 열고 들어오라고 함.」'),
              n('그 조식 덕분에 세 사람이 살았다. 병원에서는 한 시간만 늦었어도 달랐을 것이라고 했다.'),
            ],
            gives: ['breakfast'],
          },
        ],
      },
      {
        id: 'experiment',
        label: '밤샘 재현 실험을 지켜본다',
        showWhen: { flag: 'night' },
        variants: [
          {
            lines: [
              n('윤은호는 해송동을 그날 밤과 똑같이 만들어 놓았다. 연통을 빼고, 방문을 닫고, 보일러를 쉬지 않고 돌게 했다.'),
              n('다락과 안방, 작은방에 측정기를 하나씩 두고 우리는 관리동으로 물러났다. 노트북 화면에 선 세 개가 그려지기 시작했다.'),
              say('eunho', '여덟 시간 걸립니다. 형사님은 들어가 주무셔도 되는데요.'),
              me('옆에서 지켜봐야 한다면서요.'),
              say('eunho', '…그건 핑계였습니다. 반쯤은.'),
              n('관리동 난로는 주인이 퇴근하면서 꺼 놓았다. 윤은호는 핫팩 하나를 뜯어 한참 흔들더니 내 손에 쥐여 주고, 자판기에서 율무차 두 잔을 뽑아 왔다.'),
              n('두어 시간이 지나자 맨 위의 선이 가파르게 치솟았다. 다락이다. 아래의 두 선은 나란히, 천천히 올라간다.'),
              say('eunho', '다락은 한두 시간이면 쓰러질 농도입니다. 안방과 작은방은 그 6분의 1쯤이고요. 문이 닫혀 있어서 틈으로만 들어가니까요.'),
              say('eunho', '하지만 6분의 1이라도 여덟 시간이면 얘기가 다릅니다. 피 속 수치로 치면 30% 안팎까지 올라가요. 안방에서 잔 두 분이 34%와 29%였죠. 딱 그렇습니다.'),
              me('작은방도요?'),
              say('eunho', '작은방도요. 두 방의 선은 거의 겹칩니다.'),
              n('윤은호는 화면에서 눈을 떼지 않고 말을 이었다.'),
              say('eunho', '부모님이 불로 돌아가셨습니다. 제가 고3 때요. 두 분이 밤마다 물류센터에서 일하셨는데, 불이 났을 때 스프링클러가 잠겨 있었대요.'),
              say('eunho', '왜 났는지, 왜 못 나왔는지 아무도 제대로 말해 주지 않았습니다. 그래서 제가 대답하는 사람이 되기로 했어요.'),
              n('나는 박 반장 얘기를 했다. 믹스커피 상자를 아직 못 버렸다는 얘기까지. 윤은호는 끝까지 들었다.'),
              n('긴 밤이 끝나 갈 무렵, 선 세 개가 평평해졌다. 담요가 한 장뿐이라 반씩 덮고 있었다는 것을, 일어설 때에야 알았다.'),
              say('eunho', '오늘 저녁에 서해과학관으로 오실래요. 화요일과 토요일은 밤까지 여는 날이라서요.'),
              say('eunho', '이 결과로 설명할 게 있습니다. …보여 드리고 싶은 것도 있고요.'),
              n('저녁까지는 한나절이 남았다. 그 전에 확인할 것들이 있다.'),
            ],
            gives: ['experiment', 'parents'],
            flag: 'invite',
          },
        ],
      },
    ],
  },
  {
    id: 'hospital',
    name: '서해의료원',
    desc: '응급실 옆 관찰 병동. 임서연과 임다영은 2인실에, 도현우는 복도 끝 1인실에 있다. 세 사람 모두 코에 산소 줄을 꽂고 있다.',
    hotspots: [
      {
        id: 'labs',
        label: '응급실 기록을 본다',
        variants: [
          {
            lines: [
              n('응급의학과 당직의가 차트를 넘겨 줬다. 도착 직후 뽑은 피의 일산화탄소 수치다.'),
              n('「도정훈 58%(사후 채혈). 임서연 34%. 임다영 29%. 도현우 9%.」'),
              say('doc', '50%를 넘으면 대개 못 버팁니다. 30% 안팎이면 심한 두통에 구토, 의식이 흐려지고요. 두 분은 한 시간만 늦었어도 위험했습니다.'),
              say('doc', '아드님은 경증입니다. 두통을 호소해서 관찰 중이에요.'),
            ],
            gives: ['cohb'],
          },
        ],
      },
      {
        id: 'ambulance',
        label: '구급 기록을 본다',
        variants: [
          {
            lines: [
              n('119 구급대의 현장 기록. 세 사람의 손가락에 집게형 측정기를 물려 잰 산소포화도는 97, 98, 98.'),
              me('수치가 전부 정상인데요.'),
              say('doc', '그 기계는 헤모글로빈에 뭔가 붙어 있는지만 봅니다. 붙은 게 산소인지 일산화탄소인지는 구분을 못 해요. 그래서 중독 환자도 정상으로 나옵니다.'),
              say('doc', '돌아가신 분에게 선홍색 반점이 없었다면서요. 그건 열에 셋 정도에서만 나타납니다. 피를 뽑아 보기 전에는 아무도 몰라요.'),
            ],
            gives: ['oximeter'],
          },
        ],
      },
      {
        id: 'chart',
        label: '임서연의 지난 진료 기록을 본다',
        variants: [
          {
            lines: [
              n('임서연은 이 병원에 기록이 있다. 올해 10월, 응급실.'),
              n('「좌측 늑골 2개 골절. 환자 진술: 계단에서 넘어짐.」 그 밑에 엑스레이를 본 의사의 메모. 「과거 골절이 붙은 흔적 다수.」'),
              n('계단은 사람의 갈비뼈를 여러 해에 걸쳐 여러 번 부러뜨리지 않는다.'),
            ],
            gives: ['ribs'],
          },
        ],
      },
      {
        id: 'retest',
        label: '다음 날 재검 결과를 본다',
        showWhen: { clue: 'brother' },
        variants: [
          {
            lines: [
              n('월요일 아침에 다시 뽑은 피가 있었다. 「임서연 2%. 임다영 1%. 도현우 8%.」'),
              say('nurse', '두 분은 깨끗하게 빠졌어요. 아드님은… 수치가 그대로네요. 그럴 만도 해요.'),
              me('그럴 만하다니요.'),
              say('nurse', '그 환자분, 산소 줄 빼고 자꾸 주차장에 나가서 담배 피우세요. 하루에 한 갑은 태우시는 것 같아요. 몇 번을 말씀드렸는데.'),
              n('9%, 그리고 8%. 하루가 지나도 거의 그대로다. 이 숫자를 들고 토요일 밤을 처음부터 다시 따져 봐야 한다.'),
            ],
            gives: ['retest'],
          },
        ],
      },
      {
        id: 'lobby',
        label: '로비 CCTV를 본다',
        showWhen: { clue: 'tip' },
        variants: [
          {
            when: { clue: 'brother' },
            lines: [
              n('익명 제보는 일요일 오후 2시 20분, 이 병원 로비의 공중전화에서 걸렸다. 로비 영상은 바깥 보안업체가 보관한다. 요청해 둔 영상이 화요일 밤에야 와 있었다.'),
              n('영상을 그 시각으로 돌렸다. 공중전화 앞에 환자복 차림의 남자가 서 있다. 링거 걸이를 끌고, 한 손으로 수화기를 감싸 쥐고.'),
              n('통화는 1분 12초. 남자가 돌아서면서 얼굴이 카메라에 잡힌다.'),
              n('도현우다.'),
            ],
            gives: ['payphone'],
          },
          {
            lines: [
              n('익명 제보는 일요일 오후 2시 20분, 이 병원 로비의 공중전화에서 걸렸다.'),
              n('로비 카메라의 영상은 병원이 아니라 바깥 보안업체가 보관한다. 영상을 달라는 요청서를 넣었다. 회신은 빨라야 화요일 밤이라고 했다.'),
              n('강 팀장은 그 전화를 건 사람이 누구인지 확인하지 않고 체포부터 했다.'),
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'station',
    name: '서해경찰서',
    desc: '강력2팀 사무실. 박 반장의 창가 자리에는 강 팀장이 앉아 있다. 책상 위는 서류 한 장 없이 깨끗하다. 강 팀장은 결재할 것만 올려놓는 사람이다.',
    hotspots: [
      {
        id: 'prints',
        label: '지문 감식 결과를 본다',
        variants: [
          {
            lines: [
              n('과학수사팀의 감식 결과.'),
              n('「거실 온도조절기 버튼: 임서연의 우측 검지.」 「경보기 전원 플러그: 임다영의 우측 엄지와 검지.」'),
              n('보일러를 밤새 돌게 한 손도, 경보기를 뽑은 손도, 그 모녀의 것이다.'),
            ],
            gives: ['fingerprints'],
          },
        ],
      },
      {
        id: 'policy',
        label: '보험 조회 결과를 본다',
        variants: [
          {
            lines: [
              n('「피보험자 도정훈. 사망 시 5억. 수익자 임서연. 2년 전 가입.」'),
              n('남편이 죽으면 아내가 5억을 받는다.'),
            ],
            gives: ['insurance'],
          },
        ],
      },
      {
        id: 'history',
        label: '112 신고 이력을 본다',
        variants: [
          {
            lines: [
              n('도정훈의 자택 주소로 지난 3년간 접수된 신고가 세 건.'),
              n('「여자 비명 소리.」 「부부 싸움, 물건 깨지는 소리.」 「딸의 신고: 엄마가 맞고 있다.」'),
              n('세 건 모두 처리 결과는 같다. 「현장 종결. 피해자가 처벌을 원하지 않음.」'),
              n('누군가 세 번을 열어 보고, 세 번을 닫았다.'),
            ],
            gives: ['calls112'],
          },
        ],
      },
      {
        id: 'tipcall',
        label: '익명 제보 기록을 본다',
        showWhen: { flag: 'arrest' },
        variants: [
          {
            lines: [
              n('일요일 오후 2시 20분, 강력팀으로 걸려 온 전화. 강 팀장이 직접 받았다. 녹음을 틀었다.'),
              say('caller', '그 집 여자, 남편한테 맞고 살았습니다. 남편 앞으로 보험도 들어 놨고요. 어젯밤 보일러 올린 것도 그 여자예요.'),
              n('남자 목소리다. 일부러 낮게 깐 것 같다. 이름은 대지 않았다. 발신지는 서해의료원 로비의 공중전화.'),
            ],
            gives: ['tip'],
          },
        ],
      },
      {
        id: 'phone',
        label: '현장에서 거둬 온 휴대폰을 본다',
        showWhen: [{ clue: 'chargeAsk' }, { flag: 'invite' }],
        variants: [
          {
            lines: [
              n('거실 콘센트의 충전기에 물려 있던 휴대폰이 과학수사팀에서 넘어왔다. 화면은 여전히 잠겨 있다.'),
              n('통신사에 가입자를 물은 회신이 봉투에 붙어 있다. 「가입자 도현우.」'),
              n('구급대가 찍은 현장 사진과도 맞춰 봤다. 경보기가 꽂혀 있어야 할 바로 그 콘센트에서, 이 휴대폰이 충전되고 있었다.'),
            ],
            gives: ['phone'],
          },
        ],
      },
      {
        id: 'bag',
        label: '피해자의 서류 가방을 본다',
        showWhen: { flag: 'invite' },
        variants: [
          {
            lines: [
              n('도정훈이 여행에 들고 온 서류 가방이 감식을 마치고 넘어왔다. 앞으로 열흘의 일정이 빽빽하다.'),
              n('「정훈건설 주식 양수도 계약서(안). 12월 12일 체결.」 회사를 통째로 파는 계약이다.'),
              n('「입양 신고서. 양자 임다영.」 양아버지 칸에는 도정훈의 도장이 찍혀 있고, 임다영 본인의 서명란만 비어 있다. 그리고 도정훈의 휴대폰에 온 문자 한 통. 「12월 16일 유언 공증 예약 확인.」'),
              n('도정훈은 며칠 뒤에 회사를 팔고 유언을 새로 쓸 참이었다. 의붓딸을 법적인 딸로 올리는 서류도 서명 하나만 남겨 두고 있었다.'),
            ],
            gives: ['sale'],
          },
        ],
      },
      {
        id: 'counsel',
        label: '회사 고문 변호사에게 전화한다',
        showWhen: { clue: 'sale' },
        variants: [
          {
            lines: [
              n('서류를 만든 정훈건설의 고문 변호사에게 전화를 걸었다. 변호사는 한참 망설이다 입을 열었다.'),
              say('lawyer', '지난달에 아드님이 혼자 찾아왔습니다. 걱정이 돼서 묻는다면서요.'),
              say('lawyer', '새어머니가 아버지를 원망하는 것 같다. 만에 하나 새어머니가 아버지를 해쳐서 유죄가 되면 상속은 어떻게 되느냐고 물었습니다.'),
              say('lawyer', '그러면 새어머니는 한 푼도 못 받고, 그 몫까지 전부 아드님에게 간다고 답해 줬지요. 그때는 아버지를 걱정하는 아들이라고 생각했습니다. 상담 일지에 적어 뒀고요.'),
            ],
            gives: ['lawyer'],
          },
        ],
      },
    ],
  },
  {
    id: 'museum',
    name: '서해과학관',
    showWhen: [{ flag: 'invite' }, { flag: 'dusk' }],
    desc: "화요일 밤의 과학관. 야간 개장이라 관람객은 드문드문하다. 윤은호는 입구에서 '해설 자원봉사' 명찰을 목에 걸고 기다리고 있었다. 주말마다 여기서 아이들에게 불 이야기를 해 준다고 했다.",
    hotspots: [
      {
        id: 'blood',
        label: '인체관의 헤모글로빈 모형 앞에 선다',
        variants: [
          {
            lines: [
              n('사람 키만 한 붉은 모형. 네 개의 자리에 파란 공이 붙었다 떨어졌다 한다. 산소다.'),
              say('eunho', '헤모글로빈은 산소를 붙였다가, 필요한 데 가서 놓아 줍니다. 놓아 주니까 쓸모가 있는 거예요.'),
              say('eunho', "일산화탄소는 같은 자리에 산소보다 200배 넘게 세게 붙습니다. 그리고 좀처럼 안 놓아요. 한번 붙으면 산소가 앉을 자리가 없어집니다. 그게 이 중독의 전부예요. 나쁜 '결합'이죠."),
              say('eunho', '떨어지는 데는 시간이 걸립니다. 맑은 공기에서 네 시간에서 여섯 시간마다 절반씩. 하루면 거의 다 빠져요.'),
              me('담배를 피우는 사람은요.'),
              say('eunho', '흡연자는 평소에도 3에서 10%가 나와요. 담배 연기에 일산화탄소가 들어 있으니까요. 그래서 흡연자는 10%를 넘어야 중독으로 봅니다.'),
              n('도현우의 9%. 수첩에서 그 숫자를 다시 찾았다.'),
              n('하루 뒤에 다시 잰 수치가 병원에 있을 것이다. 과학관을 나서면 그것부터 확인해야겠다.'),
            ],
            gives: ['halfLife'],
          },
        ],
      },
      {
        id: 'table',
        label: '주기율표 벽 앞에 선다',
        showWhen: { clue: 'halfLife' },
        variants: [
          {
            lines: [
              n('벽 한 면이 통째로 주기율표다. 칸마다 불이 들어오고, 구석에는 작은 번호가 적혀 있다. 윤은호가 리모컨으로 칸을 하나씩 차례로 켰다.'),
              say('eunho', '제 이름입니다. Y, U, N, Eu, N, Ho. 이트륨, 우라늄, 질소, 유로퓸, 질소, 홀뮴. 윤은호.'),
              say('eunho', '아버지가 화학 선생님이셨어요. 저희 이름을 여기서 고르셨대요.'),
              me('저희요?'),
              say('eunho', '동생이 있습니다. 걔는 다섯 개예요. 저보다 하나 적다고 어릴 때 엄청 놀렸죠.'),
              n('작년 겨울 412호의 벽에서 같은 놀이를 본 적이 있다. 그때는 쓸데없다고 생각했다.'),
              me('제 이름은 안 되죠. J가 없어서.'),
              say('eunho', '…아셨어요? 저도 해 봤는데요. Seo까지는 셀레늄과 산소로 되는데, Ji에서 막힙니다.'),
              me('그럼 저는 주기율표에 없는 사람이네요.'),
              say('eunho', '그래서 찾기 힘들었나 봅니다. 아홉 달 동안.'),
              n('윤은호는 말해 놓고 자기가 더 놀란 얼굴을 했다. 나는 불 켜진 칸들을 한참 봤다.'),
            ],
            gives: ['nameGame'],
          },
        ],
      },
      {
        id: 'roof',
        label: '옥상 천문대에 올라간다',
        showWhen: { clue: 'nameGame' },
        variants: [
          {
            lines: [
              n('옥상은 추웠다. 망원경 차례를 기다리는데 윤은호의 휴대폰 화면이 켜졌다. 윤은호는 감추지 않았다.'),
              n('「형. 올해도 납골당은 나 혼자 다녀왔어.」 보낸 사람, 시호.'),
              say('eunho', '동생입니다. 내일이 부모님 기일이에요. 저는 매번 조사 일정이 겹쳐서요. …핑계지만.'),
              say('eunho', '해마다 이맘때 문자 한 통이 옵니다. 걔는 불을 막는 일을 해요. 소방 설비. 저는 불난 뒤를 보고요. 같은 일을 겪고 반대쪽으로 갔죠.'),
              n('윤은호는 답장을 쓰다 지우고, 휴대폰을 주머니에 넣었다. 나는 묻지 않았다.'),
              n('망원경 속 목성에는 줄무늬가 있었다. 윤은호가 옆에서 초점을 맞춰 주는 동안 손등이 한 번 닿았다. 둘 다 치우지 않았다.'),
            ],
            gives: ['brother'],
          },
        ],
      },
    ],
  },
  {
    id: 'parking',
    name: '해변 공영주차장',
    showWhen: { clue: 'retest' },
    desc: '펜션에서 300미터 떨어진 해변 공영주차장. 겨울이라 차는 몇 대 없다. 도현우의 검은 SUV는 토요일부터 여기 서 있었다. 펜션 주차장이 좁다면서.',
    hotspots: [
      {
        id: 'lot',
        label: '방범 카메라를 확인한다',
        variants: [
          {
            lines: [
              n('주차장 입구에 시청 방범 카메라가 있다. 밤에도 사람이 지키는 시청 관제실에서 토요일 밤 영상을 받았다.'),
              n('00시 12분, 패딩 모자를 눌러쓴 남자가 걸어와 검은 SUV의 문을 연다. 실내등이 켜지면서 얼굴이 잠깐 드러난다. 도현우다.'),
              n('00시 14분, 배기구에서 흰 김이 오르기 시작한다. 그 김은 아침까지 끊기지 않는다.'),
              n('07시 26분, 김이 멎는다. 도현우가 내려서 펜션 쪽으로 걸어간다.'),
              n('일곱 시간 넘게, 도현우는 시동을 건 차 안에 있었다. 가족이 자고 있던 집이 아니라.'),
            ],
            gives: ['carlog'],
          },
        ],
      },
    ],
  },
];

export const VICTIM = {
  id: 'victim',
  name: '도정훈',
  age: 59,
  role: '정훈건설 대표',
  tag: '피해자',
  desc: '지역 건설사 대표. 생일 여행을 온 펜션의 다락에서 혼자 자다 일산화탄소 중독으로 숨졌다.',
};

export const PEOPLE = [
  {
    id: 'eunho',
    name: '윤은호',
    age: 32,
    role: '국과수 연구관',
    tag: '감식',
    loc: 'boiler',
    desc: '아홉 달 전 대성제분 화재에서 만난 국과수 연구관. 이번 가스 사고 조사를 맡았다. 여전히 대답보다 설명이 먼저 나온다.',
    topics: [
      {
        id: 'slip',
        label: '연통이 저절로 빠질 수 있는가',
        lines: [
          say('eunho', '나사가 박혀 있으면 안 빠집니다. 실험실에서 같은 연통을 며칠씩 흔들어 봐도요. 강릉은 그 고정이 처음부터 부실했던 겁니다.'),
          say('eunho', '여기는 한 달 전 점검 때 나사가 있었다면, 그 뒤에 누가 푼 거죠. 주인분한테 점검 기록이 있을 겁니다.'),
        ],
      },
      {
        id: 'driver',
        label: '관리동 드라이버를 맞춰 본 결과',
        when: [{ clue: 'driver' }, { flag: 'invite' }],
        lines: [
          say('eunho', '실험을 기다리는 동안 확대경으로 맞춰 봤습니다. 관리동 드라이버는 날 한쪽 귀가 떨어져 나갔어요. 그걸로 돌리다 미끄러지면 그 이 빠진 모양이 자국에 그대로 찍힙니다.'),
          say('eunho', '연통 띠에 난 자국은 네 귀가 온전한 십자입니다. 날에 묻은 쇳가루도 달라요. 아연을 입힌 나사에서 나온 건데, 연통 띠와 거기 쓰는 나사는 스테인리스거든요.'),
          say('eunho', '주인분은 그 드라이버로 해송동 뒤 울타리의 경첩을 조였다고 하더군요. 가 보니 새 나사가 박혀 있었습니다. 연통을 푼 건 다른 드라이버예요.'),
        ],
        gives: ['driverTest'],
      },
    ],
    present: {
      cohb: {
        lines: [
          say('eunho', '58, 34, 29, 9. 이 숫자는 혼자서는 안 읽힙니다. 방마다 가스가 얼마나 찼는지를 옆에 놓고 봐야 해요.'),
        ],
      },
      alarm: {
        lines: [
          say('eunho', '경보기라는 글씨는 본체 옆면에 작게 찍혀 있습니다. 모르는 사람 눈에는 방향제나 공유기로 보여요. 보일러를 만지는 일을 하는 사람이라면 한눈에 알아보겠지만요.'),
        ],
      },
      thermostat: {
        lines: [
          say('eunho', '30도 연속이면 보일러가 쉬지 않습니다. 연통이 빠진 채로 제일 많이 태우게 만든 거죠.'),
        ],
      },
      driver: {
        lines: [
          say('eunho', '연통 나사에 맞는 크기네요. 날 끝을 확대해서 연통에 난 자국과 맞춰 보겠습니다. 시간을 좀 주세요.'),
        ],
      },
    },
    fallback: [say('eunho', '그건 제가 볼 수 있는 범위 밖이네요. 그래도 같이 생각해 보죠.')],
  },
  {
    id: 'bang',
    name: '방덕수',
    age: 64,
    role: '펜션 주인',
    tag: '용의자',
    loc: 'lodge',
    desc: '파도소리 펜션 주인. 조식 바구니를 들고 갔다가 네 사람을 발견해 119를 불렀다. 보일러 관리 책임자이고, 숨진 도정훈의 회사와 소송 중이다.',
    topics: [
      {
        id: 'find',
        label: '발견했을 때',
        lines: [
          say('bang', '여덟 시 정각에 미역국 들고 갔지요. 꼭 정각에 오라는 당부가 있어서. 두드려도 기척이 없어서 십 분쯤 있다가 열쇠로 열었습니다.'),
          say('bang', '들어서자마자 머리가 띵합디다. 안방 문 열어 보니 모녀가 누워 있는데 흔들어도 안 깨요. 작은방 아드님은 그래도 눈을 뜨더만. 「머리가… 머리가 아파요」 하고.'),
        ],
      },
      {
        id: 'care',
        label: '보일러 관리',
        lines: [
          say('bang', '매달 가스 업체가 와서 봅니다. 지난달에도 왔고요. 사진까지 찍어 갔어요. 저기 벽에 있습니다.'),
          say('bang', '경보기도 동마다 달았습니다. 강릉 일 나고서 법이 바뀌어서. 손님들이 가끔 충전한다고 뽑아 놓긴 하는데…'),
        ],
      },
      {
        id: 'grudge',
        label: '도정훈과의 관계',
        lines: [
          say('bang', '…숨길 것도 없지요. 저 별채 두 동을 정훈건설이 지었습니다. 첫 겨울에 벽이 다 터졌어요. 하자 보수를 3년째 안 해 줘서 소송 중입니다.'),
          say('bang', '그래도 해마다 생일이면 옵디다. 「방 사장, 소송은 소송이고 장사는 장사지」 하면서. 미운 사람이었지만, 내 펜션에서 죽으라고 빌 만큼은 아닙니다.'),
        ],
        gives: ['ownerGrudge'],
      },
      {
        id: 'cars',
        label: '가족의 차',
        lines: [
          say('bang', '도 대표 차는 저 앞에 있고, 아드님 SUV는 해변 공영주차장에 댔습니다. 여기 자리가 좁다면서. …자리는 남았는데.'),
        ],
      },
      {
        id: 'eight',
        label: '8시 정각이라는 당부',
        when: [{ clue: 'breakfast' }, { clue: 'carlog' }],
        lines: [
          me('8시 정각에, 대답이 없으면 열고 들어오라는 당부는 누가 한 겁니까.'),
          say('bang', '아드님이지요. 예약은 도 대표 이름으로 했어도 전화는 아드님이 했습니다.'),
          say('bang', '「8시 정각에, 대답 없으면 열고 들어오세요」라고 두 번이나 다짐을 받습디다. 아버지 생신상을 그렇게 챙기나, 효자다 싶었지요.'),
        ],
        gives: ['breakfastAsk'],
      },
    ],
    present: {
      breakfast: {
        lines: [
          say('bang', '그 메모요? 예약 전화 받으면서 내가 받아 적은 겁니다. 생신 아침이니 미역국을 꼭 제시간에 넣어 달라고 해서요.'),
        ],
      },
      flue: {
        lines: [
          say('bang', '나사가 없다고요? 그럴 리가. 지난달 사진 보십시오. 두 개 다 박혀 있습니다.'),
        ],
      },
      driver: {
        lines: [
          say('bang', '그 드라이버요? 금요일에 해송동 뒤 울타리 경첩이 덜렁거려서 조였습니다. 가서 보십시오. 새 나사가 박혀 있을 겁니다.'),
          say('bang', '…설마 내가 연통을 풀었다는 말입니까. 내 펜션에서, 내 손님을.'),
        ],
      },
    },
    fallback: [say('bang', '그건 내가 알 수가 없지요.')],
  },
  {
    id: 'seoyeon',
    name: '임서연',
    age: 47,
    role: '도정훈의 아내',
    tag: '용의자',
    loc: 'hospital',
    desc: '3년 전 도정훈과 재혼했다. 그 전에는 정훈건설의 경리였다. 말끝마다 「죄송합니다」가 붙는다. 긴소매 환자복 소매를 자꾸 끌어내린다.',
    topics: [
      {
        id: 'night',
        label: '그날 밤',
        lines: [
          say('seoyeon', '상은 아침에 치우려고 그냥 두고, 열한 시 넘어서 딸이랑 안방에 누웠어요. 그이는 술을 많이 해서 일찍 다락으로 올라갔고요.'),
          say('seoyeon', '눈을 떠 보니 병원이었어요. 죄송합니다. 제가 잘 챙겼어야 했는데.'),
        ],
      },
      {
        id: 'heat',
        label: '온도조절기',
        when: { clue: 'thermostat' },
        lines: [
          me('23시 40분에 조절기를 30도 연속으로 올린 사람이 있습니다.'),
          say('seoyeon', '…제가 올렸어요. 그이가 춥다고 해서요.'),
          say('seoyeon', '그이는 추우면 화를 내요. 그래서 제일 높게, 안 꺼지게 해 놨어요. 죄송합니다.'),
        ],
        flag: 'heatSaid',
      },
      {
        id: 'asleep',
        label: '남편은 그 시각에 자고 있었다',
        when: [{ flag: 'heatSaid' }, { clue: 'watch' }],
        lines: [
          me('도정훈 씨의 시계 기록입니다. 22시 52분에 잠들어서 한 번도 깨지 않았습니다. 23시 40분에 춥다고 말할 수는 없었습니다.'),
          say('seoyeon', '…그이한테 직접 들은 건 아니에요.'),
          say('seoyeon', '현우가 그랬어요. 「어머니, 아버지가 위에서 춥다고 하시네요. 보일러 좀 세게 올려 주세요」 하고.'),
          say('seoyeon', '저는 다락에 올라가 보지도 않았어요. 자는 사람을 깨우면 혼나니까요. 죄송합니다.'),
        ],
        gives: ['heatAsk'],
      },
      {
        id: 'husband',
        label: '남편에 대해',
        lines: [
          say('seoyeon', '밖에서는 다들 좋은 분이라고 해요. 통도 크고. …집에서도 좋은 분이었어요.'),
          n('임서연은 그 말을 하면서 왼쪽 옆구리에 손을 얹었다. 갈비뼈가 있는 자리다.'),
        ],
      },
      {
        id: 'confess',
        label: '긴급체포된 뒤',
        when: { flag: 'arrest' },
        lines: [
          n('병실 문 앞에 순경이 서 있다. 임서연의 한쪽 손목은 침대 난간에 수갑으로 채워져 있다. 임서연은 나를 보자마자 말했다.'),
          say('seoyeon', '제가 했어요. 다영이는 아무것도 몰라요. 경보기도 제가 뽑으라고 시켰어요.'),
          me('연통은 어떻게 하셨습니까.'),
          say('seoyeon', '손으로… 손으로 잡아당겨서 뺐어요. 저녁 준비하다가, 아홉 시쯤에요.'),
          me('보일러실에는 어떻게 들어가셨고요.'),
          say('seoyeon', '열쇠로요. 관리동에서 열쇠를 빌려서…'),
          n('나는 수첩을 덮지 않았다. 방금 들은 말 가운데, 내가 보일러실에서 본 것과 맞지 않는 데가 있다.'),
        ],
        gives: ['confession'],
      },
    ],
    present: {
      ribs: {
        lines: [
          say('seoyeon', '…계단에서 넘어진 거예요. 정말이에요.'),
          n('임서연은 내 눈을 보지 않았다. 한참 뒤에 아주 작게 말했다.'),
          say('seoyeon', '다영이 등록금을 그이가 내요. 제가 참으면 다 되는 일이었어요.'),
        ],
      },
      insurance: {
        lines: [
          say('seoyeon', '보험은 그이가 들었어요. 「내가 죽어도 너 굶지는 않게 해 준다」고. 저는 얼마짜리인지도 몰랐어요.'),
        ],
      },
      watch: {
        lines: [
          say('seoyeon', '그이 시계예요. 잘 때도 차고 자요. 건강은 끔찍이 챙기던 사람이라.'),
        ],
      },
      sale: {
        lines: [
          say('seoyeon', '입양이요? 그이가 다영이를 자기 딸로 올려 주겠다고는 했어요. 「이제 진짜 내 딸이다」 하면서. 다영이는 싫다고 했는데.'),
        ],
      },
    },
    fallback: [say('seoyeon', '죄송합니다. 그건 잘 모르겠어요.')],
  },
  {
    id: 'dayoung',
    name: '임다영',
    age: 22,
    role: '임서연의 딸 · 간호학과',
    tag: '용의자',
    loc: 'hospital',
    desc: '간호학과 3학년. 병실에서도 엄마의 산소 줄이 꼬이지 않았는지부터 본다. 의붓아버지 얘기가 나오면 입을 다문다.',
    topics: [
      {
        id: 'night',
        label: '그날 밤',
        lines: [
          say('dayoung', '저는 엄마랑 안방에서 잤어요. 새벽에 한 번 깼는데 머리가 너무 아프고 토할 것 같았어요. 일어나려는데 다리에 힘이 안 들어가서… 그러고는 기억이 없어요.'),
          say('dayoung', '실습 때 배웠는데. 두통에 구역질이면 일산화탄소를 의심하라고. 배운 걸 제 몸으로는 못 알아챘어요.'),
        ],
      },
      {
        id: 'plug',
        label: '경보기',
        when: [{ clue: 'alarm' }, { clue: 'fingerprints' }],
        lines: [
          me('거실 경보기가 뽑혀 있었습니다. 전원 플러그에서 임다영 씨의 지문이 나왔습니다.'),
          say('dayoung', '…제가 뽑았어요. 오빠가 그랬어요. 「다영아, 충전기 좀 꽂게 그거 뽑아 줄래? 콘센트가 거기밖에 없네」 하고요.'),
          say('dayoung', '그게 경보기인 줄 몰랐어요. 하얗고 네모난 게 꽂혀 있길래 방향제인 줄 알았어요. 간호학과가 그것도 모르냐고 하시겠지만.'),
        ],
        gives: ['chargeAsk'],
      },
      {
        id: 'dinner',
        label: '생일상에서 있었던 일',
        when: { flag: 'cake' },
        lines: [
          me('식탁에 케이크 한 조각이 손도 안 댄 채 남아 있더군요.'),
          say('dayoung', '오빠 거예요. 초를 끄고 나서 아저씨가 그랬거든요. 다음 주에 회사를 판다고. 오빠한테는 「넌 네 힘으로 살아라」 하고요.'),
          say('dayoung', '오빠는 웃으면서 「네, 아버지」 했어요. 그러고는 케이크에 손을 안 댔어요. 담배 피우고 온다고 나갔고요.'),
          say('dayoung', '그 전에는 엄마가 국이 식었다고 한 소리 들었어요. 생일이라 그 정도로 끝난 거예요.'),
        ],
        gives: ['dinner'],
      },
      {
        id: 'stepfather',
        label: '의붓아버지에 대해',
        lines: [
          say('dayoung', '…………'),
          say('dayoung', '죽었으면 좋겠다고 생각했어요. 여러 번요. 엄마 갈비뼈 사진을 실습 나간 병원에서 제 눈으로 봤어요.'),
          say('dayoung', '근데 형사님, 저는 그 집에서 엄마를 데리고 나오고 싶었던 거지, 엄마 옆에 누워서 같이 가스를 마시고 싶었던 게 아니에요.'),
        ],
      },
      {
        id: 'stepbrother',
        label: '도현우에 대해',
        lines: [
          say('dayoung', '오빠요? 저희한테 잘해 줬어요. 아저씨가 소리 지르면 오빠가 말리는 척이라도 했고요.'),
          say('dayoung', "근데 한 번도 엄마를 진심으로 '어머니'라고 부른 적은 없는 것 같아요. 그날 밤에는 유난히 많이 불렀지만요."),
        ],
      },
    ],
    present: {
      calls112: {
        lines: [
          say('dayoung', '세 번째 신고는 제가 했어요. 경찰 아저씨가 엄마한테 물었어요. 「처벌 원하세요?」 엄마가 아니라고 하니까 그냥 갔어요. 5분도 안 걸렸어요.'),
        ],
      },
      fingerprints: {
        lines: [
          say('dayoung', '제 지문이 나왔다고요. …네, 제가 뽑았으니까요. 근데 형사님, 그 콘센트에 그다음에 뭐가 꽂혔는지도 봐 주세요.'),
        ],
      },
      sale: {
        lines: [
          say('dayoung', '입양은 싫다고 했어요. 그 사람 딸로 서류에 오르고 싶지 않았어요. 그래서 서명도 안 했어요.'),
        ],
      },
    },
    fallback: [say('dayoung', '그건… 저도 잘 모르겠어요.')],
  },
  {
    id: 'hyunwoo',
    name: '도현우',
    age: 31,
    role: '도정훈의 아들 · 정훈건설 설비팀',
    tag: '용의자',
    loc: 'hospital',
    desc: '도정훈의 외아들. 아버지 회사의 설비팀에서 10년을 일했다. 침대에 앉아서도 넥타이를 맨 사람처럼 반듯하다. 아버지 얘기를 할 때마다 말을 고른다.',
    topics: [
      {
        id: 'night',
        label: '그날 밤',
        lines: [
          say('hyunwoo', '열한 시쯤 작은방에 들어가 잤습니다. 아침에 사장님이 흔들어 깨우셔서 눈을 떴고요. 머리가 깨질 것 같았습니다.'),
          say('hyunwoo', '아버지는… 제가 좀 더 일찍 깼어야 했는데.'),
        ],
        gives: ['hyunwooStory'],
      },
      {
        id: 'boiler',
        label: '보일러에 대해',
        lines: [
          say('hyunwoo', '제가 설비 일을 해서 압니다. 저런 연통은 시공할 때 고정을 대충 하면 진동으로 빠집니다. 강릉 사고가 딱 그랬죠.'),
          say('hyunwoo', '펜션 사장님이 관리를 소홀히 하신 겁니다. 아버지 회사와 소송 중이기도 했고요. …아니, 그분이 일부러 그랬다는 말은 아닙니다.'),
        ],
      },
      {
        id: 'stepmother',
        label: '새어머니에 대해',
        lines: [
          say('hyunwoo', '좋은 분입니다. 아버지 성격을 다 받아 주셨어요. 그럴 분이 아닙니다.'),
          say('hyunwoo', '…그날 밤에 보일러를 세게 올리시긴 했습니다만. 아버지가 추위를 타시니까 그러셨겠지요.'),
        ],
      },
      {
        id: 'deny',
        label: '보일러를 올려 달라고 했는가',
        when: { clue: 'heatAsk' },
        lines: [
          me('임서연 씨는 도현우 씨가 올려 달라고 했다고 합니다. 아버지가 춥다고 하신다면서.'),
          say('hyunwoo', '제가요? 아닙니다. 저는 그때 방에 있었습니다. 어머니가 기억을 잘못하시는 것 같습니다. 가스를 마시면 기억이 흐려진다고 하더군요.'),
        ],
      },
      {
        id: 'smoke',
        label: '담배',
        when: { clue: 'butts' },
        lines: [
          me('보일러실 앞에 꽁초가 세 개 있더군요.'),
          say('hyunwoo', '제 겁니다. 집 안에서는 못 피우게 해서 뒤로 나가서 피웠습니다. 저녁에 두어 번, 자기 전에 한 번.'),
        ],
      },
    ],
    present: {
      alarm: {
        lines: [
          say('hyunwoo', '경보기가 뽑혀 있었다고요. …손님들이 충전하느라 뽑아 놓는 일이 많다고 사장님이 그러시던데요.'),
        ],
      },
      chargeAsk: {
        lines: [
          me('임다영 씨는 도현우 씨가 부탁해서 경보기를 뽑았다고 합니다.'),
          say('hyunwoo', '충전할 자리를 좀 만들어 달라고는 했습니다. 그게 경보기였습니까. 몰랐네요.'),
        ],
      },
      phone: {
        lines: [
          say('hyunwoo', '제 휴대폰이 맞습니다. 거실에 꽂아 두고 잤습니다. 작은방에는 콘센트가 문 뒤에 있어서요.'),
        ],
      },
      cohb: {
        lines: [
          say('hyunwoo', '9%라고요. 저는 운이 좋았던 거군요. 작은방 창틀이 낡아서 외풍이 셌습니다.'),
        ],
      },
      breakfast: {
        lines: [
          say('hyunwoo', '예약은 아버지 이름으로 했습니다. 해마다 묵는 곳이라서요.'),
        ],
      },
      breakfastAsk: {
        lines: [
          say('hyunwoo', '아버지 생신이니까요. 미역국은 드셔야지요. 술 드신 다음 날은 늦게까지 주무셔서, 깨워 달라는 뜻이었습니다.'),
        ],
      },
      dinner: {
        lines: [
          say('hyunwoo', '아버지는 술이 들어가면 그런 말씀을 하십니다. 케이크는… 제가 단것을 안 좋아해서요.'),
        ],
      },
      sale: {
        lines: [
          say('hyunwoo', '매각 얘기는 알고 있었습니다. 아버지 회사니까 아버지 뜻대로 하시는 거지요. 저는 괜찮았습니다.'),
        ],
      },
      carlog: {
        lines: [
          say('hyunwoo', '…………'),
          say('hyunwoo', '그건, 변호사와 얘기하겠습니다.'),
        ],
      },
    },
    fallback: [say('hyunwoo', '그건 제가 답할 수 있는 게 아닌 것 같습니다.')],
  },
  {
    id: 'kang',
    name: '강 팀장',
    age: 47,
    role: '강력2팀장',
    tag: '팀',
    loc: 'station',
    desc: '박 반장의 뒤를 이은 새 팀장. 책상이 늘 비어 있다. 가장 단순한 답을 가장 먼저 고르고, 대개는 그게 맞았다고 했다.',
    topics: [
      {
        id: 'view',
        label: '사건을 보는 눈',
        lines: [
          say('kang', '서 경위는 박 반장님 밑에서 배웠다지. 나는 그분을 존경해. 다만 나는 일을 다르게 해.'),
          say('kang', '열에 아홉은 제일 뻔한 사람이 범인이야. 나머지 하나 때문에 아홉을 늦출 수는 없어.'),
        ],
      },
      {
        id: 'arrest',
        label: '임서연의 긴급체포',
        when: { flag: 'arrest' },
        lines: [
          say('kang', '동기 있지, 보험 있지, 지문 있지, 제보까지 들어왔어. 수요일 아침 아홉 시에 구속영장을 신청한다.'),
          say('kang', '아니라고 생각하면 그 전까지 가져와. 들을 귀는 있어.'),
        ],
      },
    ],
    present: {
      confession: {
        lines: [
          say('kang', '자백했다며. 그럼 끝난 거지. …손으로 뺐다고 했다고? 그게 왜.'),
        ],
      },
      calls112: {
        lines: [
          say('kang', '세 번 다 현장 종결이네. …우리 서에서 한 거군.'),
        ],
      },
      flue: {
        lines: [
          say('kang', '나사를 풀었다. 그래, 사고는 아니야. 문제는 누가 풀었느냐지.'),
        ],
      },
      driver: {
        lines: [
          say('kang', '펜션 주인 공구함에서 나왔다고? 원한도 있다며. …그래도 조절기와 경보기에 손댄 건 그 모녀야.'),
        ],
      },
    },
    fallback: [say('kang', '결론부터 말해.')],
  },
];

export const EXTRAS = [];

// Each plays once, on the first move after its conditions are met. The thresholds follow the
// clock in META: 12 clues is Monday morning, 18 is Monday 22:00, 23 is Tuesday morning and
// 28 is Tuesday 18:00. 28 is also every clue that can be found before the museum opens, and
// what comes after the museum waits for its last scene, so the museum is always a Tuesday night.
export const EVENTS = [
  {
    id: 'arrest',
    cluesAtLeast: 12,
    lines: [
      n('월요일. 강 팀장이 나를 찾았다.'),
      say('kang', '서 경위, 임서연 긴급체포했다. 병실 앞에 순경 세우고 수갑 채웠어.'),
      me('팀장님, 아직…'),
      say('kang', '맞고 살았고, 보험이 있고, 조절기에는 그 여자 지문, 경보기에는 딸 지문이 나왔어. 어제 오후에는 제보 전화까지 들어왔고. 내 기준에서는 충분해.'),
      say('kang', '기한은 수요일 아침 아홉 시야. 그때 구속영장을 신청한다.'),
      n('사고로 닫지 마라. 박 반장은 그렇게 말했다.'),
      n('쉬운 범인으로 닫는 것도, 닫는 것이다.'),
    ],
  },
  {
    id: 'night',
    cluesAtLeast: 18,
    when: [{ flag: 'arrest' }, { clue: 'flue' }],
    lines: [
      n('밤이 깊었다. 윤은호가 나를 찾았다.'),
      say('eunho', '형사님. 병원에서 네 사람의 혈액 수치를 받았습니다. 같은 집에서 잤는데 차이가 너무 큽니다.'),
      say('eunho', '그 집을 그날 밤과 똑같이 만들어 놓고, 방마다 가스가 얼마나 차는지 밤새 재 보려고 합니다. 준비는 끝났어요.'),
      say('eunho', '수사관이 옆에서 지켜봐야 하는 실험입니다. …그러니까, 형사님이 계셔야 합니다. 관리동에서 기다리겠습니다.'),
    ],
  },
  {
    id: 'text',
    cluesAtLeast: 23,
    when: { flag: 'invite' },
    lines: [
      n('휴대폰이 짧게 울렸다. 윤은호의 문자다.'),
      say('eunho', '측정값 정리했습니다. 참고로 형사님은 율무차를 두 잔 더 드셨습니다. 이것도 기록해 뒀습니다.'),
      n('답장을 세 번 고쳐 쓰다가 결국 한 줄만 보냈다. 「다음엔 제가 삽니다.」'),
    ],
  },
  {
    id: 'dusk',
    cluesAtLeast: 28,
    when: { flag: 'invite' },
    lines: [
      n('화요일 해가 졌다. 서해과학관이 밤까지 여는 날이다.'),
      n('윤은호는 저녁에 오라고 했다.'),
    ],
  },
];

export const DEDUCTION = {
  // Checked in order; the first missing clue decides which hint the player hears. Every clue
  // is required, in the order the days run, so the clock reads Wednesday 08:00 at the report.
  required: [
    { clue: 'flue', hint: '빠진 연통을 아직 직접 보지 않았다. 보일러실이다.' },
    { clue: 'butts', hint: '보일러실 문 앞 바닥을 아직 살피지 않았다.' },
    { clue: 'inspection', hint: '연통이 원래 멀쩡했는지 알아야 한다. 관리동의 점검 기록.' },
    { clue: 'driver', hint: '연통의 나사를 푼 공구를 찾아야 한다. 관리동에 공구함이 있다.' },
    { clue: 'breakfast', hint: '세 사람은 어떻게 제때 발견됐나. 관리동의 예약 장부.' },
    { clue: 'ownerGrudge', hint: '펜션 주인 방덕수와 숨진 도정훈의 사이를 아직 묻지 않았다.' },
    { clue: 'alarm', hint: '경보기는 왜 울리지 않았나. 1층 거실을 봐야 한다.' },
    { clue: 'thermostat', hint: '보일러가 밤새 돈 이유를 모른다. 거실의 온도조절기.' },
    { clue: 'layout', hint: '누가 어디서 잤는지, 집의 구조를 아직 살피지 않았다.' },
    { clue: 'watch', hint: '도정훈이 언제 잠들고 언제 죽었는지. 다락에 도정훈의 시계가 있다.' },
    { clue: 'cohb', hint: '병원의 혈액검사 결과를 아직 보지 않았다.' },
    { clue: 'oximeter', hint: '구급대가 현장에서 잰 수치를 아직 보지 않았다. 병원의 구급 기록.' },
    { clue: 'hyunwooStory', hint: '도현우의 그날 밤 이야기를 아직 듣지 않았다.' },
    { clue: 'fingerprints', hint: '지문 결과가 서에 와 있을 것이다.' },
    { clue: 'tip', hint: '강력팀으로 걸려 온 제보 전화가 있었다고 한다. 서에 가서 기록을 봐야 한다.' },
    { clue: 'confession', hint: '임서연의 말을 한 번 더 들어야 한다. 병원이다.' },
    { clue: 'heatAsk', hint: '23시 40분에 조절기를 올린 일을 임서연에게 물어야 한다. 그 시각에 도정훈이 자고 있었다는 것까지.' },
    { clue: 'chargeAsk', hint: '경보기 플러그에서 임다영의 지문이 나왔다. 임다영에게 물어봐야 한다.' },
    { clue: 'experiment', hint: '방마다 가스가 얼마나 찼는지 알아야 한다. 윤은호가 관리동에서 밤샘 실험을 준비한다. 아직 연락이 없다면 자리를 옮겨 보자.' },
    { clue: 'ribs', hint: '병원에 임서연의 지난 진료 기록이 남아 있다.' },
    { clue: 'insurance', hint: '강 팀장이 말한 보험. 서의 조회 결과를 봐야 한다.' },
    { clue: 'calls112', hint: '도정훈의 집에서 들어온 112 신고가 있었는지. 서의 기록.' },
    { clue: 'dinner', hint: '식탁을 다시 보자. 그러고 나서 생일상에서 무슨 일이 있었는지 임다영에게 물어보자.' },
    { clue: 'driverTest', hint: '관리동 드라이버가 연통을 푼 공구인지 가려야 한다. 보일러실의 윤은호에게 물어보자.' },
    { clue: 'phone', hint: '거실 콘센트에서 충전되던 휴대폰은 누구 것인가. 서에 넘어와 있을 것이다.' },
    { clue: 'sale', hint: '도정훈이 며칠 뒤에 하려던 일. 서에 도정훈의 서류 가방이 넘어와 있다.' },
    { clue: 'lawyer', hint: '서류를 만든 회사 고문 변호사에게 물어봐야 한다.' },
    { clue: 'halfLife', hint: '윤은호가 저녁에 서해과학관으로 오라고 했다. 해가 지면 가 보자.' },
    { clue: 'nameGame', hint: '과학관에서 윤은호가 보여 주고 싶다던 것을 아직 보지 않았다.' },
    { clue: 'brother', hint: '과학관 옥상에 아직 올라가 보지 않았다.' },
    { clue: 'retest', hint: '하루 뒤에 다시 잰 혈액 수치가 있는지, 병원에서 확인해야 한다.' },
    { clue: 'payphone', hint: '제보 전화는 병원 로비에서 걸렸다. 보안업체에 요청한 로비 영상이 왔는지 확인해야 한다.' },
    { clue: 'carlog', hint: '도현우의 차는 토요일부터 해변 공영주차장에 서 있었다.' },
    { clue: 'breakfastAsk', hint: '8시 정각에 열고 들어오라고 다짐을 받은 사람이 누구인지, 펜션 주인에게 물어야 한다.' },
  ],
  opening: [
    n('수요일 아침 여덟 시. 영장 신청까지 한 시간.'),
    n('강 팀장의 책상에는 서류가 딱 한 장 올라와 있다. 임서연의 구속영장 신청서다.'),
    say('kang', '한 시간 준다. 결론부터.'),
    me('임서연은 범인이 아닙니다. 범인은 따로 있습니다.'),
  ],
  wrong: [
    n('…아니다. 이것으로는 저 서류를 치울 수 없다.'),
    say('kang', '시간 없어. 다음.'),
  ],
  steps: [
    {
      type: 'evidence',
      label: '임서연의 자백이 사실과 다르다는 증거를 제시하라',
      prompt: [say('kang', '자백까지 한 사람이야. 뭐가 더 필요해.')],
      accept: ['flue'],
      near: {
        inspection: [n('한 달 전에는 멀쩡했다는 기록이다. 자백과 어긋나는 것은 연통 그 자체다.')],
        confession: [n('자백은 깨뜨릴 대상이다. 그것과 어긋나는 물증을 내밀어야 한다.')],
      },
      success: [
        me('임서연은 저녁 아홉 시에 연통을 손으로 잡아 뺐다고 했습니다. 관리동에서 열쇠를 빌려 보일러실에 들어갔다고요.'),
        me('연통은 나사 두 개를 드라이버로 풀고 실리콘을 칼로 잘라야 빠집니다. 보일러실 문에는 자물쇠가 없습니다. 임서연은 그 방에 들어가 본 적이 없습니다.'),
        say('kang', '…그럼 왜 자백을 해.'),
        me('경보기에서 딸의 지문이 나왔으니까요. 딸을 지키려는 겁니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '모녀가 덫을 놓은 사람이 아니라는 증거를 제시하라',
      prompt: [say('kang', '그럼 딸이네. 간호학과라며. 가스가 뭔지 제일 잘 아는 애잖아.')],
      accept: ['experiment', 'cohb'],
      near: {
        chargeAsk: [n('본인의 말이다. 강 팀장은 용의자의 말을 믿지 않는다. 몸이 말해 주는 것이 필요하다.')],
        heatAsk: [n('본인의 말이다. 강 팀장은 용의자의 말을 믿지 않는다. 몸이 말해 주는 것이 필요하다.')],
        retest: [n('하루 만에 빠졌다는 기록이다. 그보다 먼저, 두 사람이 그 밤에 얼마나 마셨는지를 보여 줘야 한다.')],
      },
      success: [
        me('응급실 수치입니다. 임서연 34%, 임다영 29%. 한 시간만 늦었어도 죽었을 수치입니다.'),
        me('재현 실험을 해 보니, 안방에서 여덟 시간을 잔 사람은 딱 그 수치가 나옵니다. 두 사람은 밤새 그 방에 있었습니다.'),
        me('덫을 놓은 사람은 덫 안에서 여덟 시간을 자지 않습니다. 가스가 뭔지 제일 잘 아는 사람이라면 더더욱요.'),
      ],
    },
    {
      type: 'evidence',
      label: '난방을 올리게 한 말이 거짓이었다는 증거를 제시하라',
      prompt: [
        say('kang', '조절기는. 그 여자 지문이야. 자기 손으로 30도까지 올렸어.'),
        me('올린 것은 맞습니다. 「아버지가 위에서 춥다고 하신다」는 말을 전해 듣고 올렸습니다. 23시 40분에요.'),
      ],
      accept: ['watch'],
      near: {
        thermostat: [n('올린 시각은 맞다. 그 시각에 다락의 도정훈이 무엇을 하고 있었는지가 문제다.')],
        heatAsk: [n('그 말을 전해 들었다는 것은 임서연의 주장이다. 그 말이 거짓이었다는 것을 보여 줘야 한다.')],
      },
      success: [
        me('도정훈의 스마트워치입니다. 22시 52분에 잠들어서 한 번도 깨지 않았습니다.'),
        me('23시 40분에 도정훈은 48분째 자고 있었습니다. 춥다고 말했을 리가 없습니다. 그 말은 누군가 지어낸 겁니다.'),
        say('kang', '그 여자가 지어낸 말일 수도 있지.'),
        me('그래서 경보기를 보셔야 합니다. 같은 수법이 한 번 더 나옵니다. 이번에는 물건이 남았습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '경보기를 뽑게 만든 사람을 가리키는 물증을 제시하라',
      prompt: [say('kang', '경보기는. 딸 지문이잖아.')],
      accept: ['phone'],
      near: {
        alarm: [n('그 콘센트에 충전기가 꽂혀 있었다는 것까지다. 그 충전기에 누구의 휴대폰이 물려 있었는지를 보여 줘야 한다.')],
        chargeAsk: [n('임다영의 말이다. 그 말을 뒷받침하는 물건이 현장에 남아 있었다.')],
        fingerprints: [n('지문은 누가 뽑았는지만 말해 준다. 왜 뽑았는지를 보여 주는 것이 따로 있다.')],
      },
      success: [
        me('경보기가 꽂혀 있던 콘센트입니다. 구급대가 도착했을 때 거기서 휴대폰 한 대가 충전되고 있었습니다.'),
        me('「충전기 좀 꽂게 그거 뽑아 줄래.」 임다영은 그 말을 듣고 뽑았습니다. 이번에는 말만 있는 게 아닙니다. 그 말을 한 사람의 휴대폰이 그 자리에 남았습니다.'),
        me('조절기에는 어머니의 지문, 경보기에는 딸의 지문. 범인은 두 장치를 자기 손으로 만지지 않았습니다. 남의 손을 빌렸습니다.'),
      ],
    },
    {
      type: 'culprit',
      label: '범인을 지목하라',
      candidates: ['seoyeon', 'dayoung', 'hyunwoo', 'bang'],
      prompt: [say('kang', '그래서 그게 누구야. 모녀의 손을 빌린 사람.')],
      accept: ['hyunwoo'],
      rebuttal: {
        seoyeon: [say('kang', '방금 네 입으로 아니라고 했잖아.')],
        dayoung: [say('kang', '딸도 덫 안에서 잤다며. 네가 한 말이야.')],
        bang: [say('kang', '펜션 주인? 그 양반 드라이버는 연통 자국하고 안 맞는다며. 가족한테 「춥다신다」고 전한 것도, 거실에 휴대폰을 꽂은 것도 그 양반이 아니고.')],
      },
      success: [
        me('도현우입니다.'),
        say('kang', '아들? 그 친구도 실려 왔어. 피에서 수치도 나왔고.'),
        me('그날 밤 도현우는 그 집에 없었습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '도현우가 그 집에서 자지 않았다는 증거를 제시하라',
      prompt: [say('kang', '없었다니. 아침에 작은방에서 발견됐잖아.')],
      accept: ['carlog'],
      near: {
        cohb: [n('피가 말해 주는 것은 그다음이다. 먼저 그날 밤 도현우가 어디에 있었는지를 보여 줘야 한다.')],
        retest: [n('피가 말해 주는 것은 그다음이다. 먼저 그날 밤 도현우가 어디에 있었는지를 보여 줘야 한다.')],
        halfLife: [n('피가 말해 주는 것은 그다음이다. 먼저 그날 밤 도현우가 어디에 있었는지를 보여 줘야 한다.')],
        experiment: [n('피가 말해 주는 것은 그다음이다. 먼저 그날 밤 도현우가 어디에 있었는지를 보여 줘야 한다.')],
        hyunwooStory: [n('도현우의 진술은 깨뜨릴 대상이다. 도현우가 실제로 있던 곳을 보여 줘야 한다.')],
        breakfastAsk: [n('발견될 시각을 미리 정해 뒀다는 증언이다. 그보다 먼저, 그 밤에 도현우가 어디에 있었는지를 보여 줘야 한다.')],
      },
      success: [
        me('해변 공영주차장의 방범 카메라입니다. 00시 12분에 도현우가 자기 차에 탑니다. 00시 14분부터 07시 26분까지 배기구의 김이 끊기지 않습니다.'),
        me('일곱 시간 동안 도현우는 시동을 건 차 안에 있었습니다. 휴대폰은 거실에 충전해 둔 채로요. 7시 반에 돌아와 작은방에 누웠고, 8시에 조식이 왔습니다.'),
        say('kang', '8시 정각에, 대답 없으면 열고 들어오라는 그 조식.'),
        me('펜션 주인에게 전화로 두 번 다짐을 받은 사람이 도현우입니다. 새어머니가 살아서 발견돼야 했으니까요.'),
      ],
    },
    {
      type: 'evidence',
      label: '도현우의 9%가 중독이 아니라는 증거를 제시하라',
      prompt: [say('kang', '그래도 9%가 나왔어. 병원이 중독이라고 진단했고.')],
      accept: ['retest', 'halfLife'],
      near: {
        cohb: [n('9%라는 숫자는 강 팀장이 든 반론이다. 그 숫자의 정체를 보여 줘야 한다.')],
        butts: [n('도현우가 담배를 피운다는 것. 맞다. 그것이 피 속 숫자와 무슨 상관인지를 보여 줘야 한다.')],
        experiment: [n('1층 어느 방에서 잤어도 30%가 나온다는 실험이다. 맞다. 하지만 강 팀장은 그래도 9%는 나왔다고 한다. 그 9%가 어디서 왔는지를 보여 줘야 한다.')],
      },
      success: [
        me('흡연자는 평소에도 3에서 10%가 나옵니다. 도현우는 하루 한 갑을 피웁니다.'),
        me('중독된 사람의 수치는 하루면 빠집니다. 모녀는 다음 날 2%, 1%였습니다. 도현우는 8%였습니다. 병원 주차장에서 계속 피웠으니까요.'),
        me('1층 어느 방에서든 여덟 시간을 잤다면 30% 안팎이 나와야 합니다. 도현우의 피는 그 집에 없었다고 말합니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '도현우의 동기를 보여 주는 증거를 제시하라',
      prompt: [say('kang', '동기는. 아버지가 죽어서 그 친구가 얻는 게 뭐야. 어차피 물려받을 아들인데.')],
      accept: ['lawyer', 'sale'],
      near: {
        insurance: [n('그것은 임서연이 의심받은 이유다. 도현우가 잃을 뻔한 것을 보여 줘야 한다.')],
        dinner: [n('생일상에서 아버지가 한 말이다. 그 말이 며칠 뒤에 실제로 무슨 일이 될 참이었는지를 보여 줘야 한다.')],
      },
      success: [
        me('도정훈은 며칠 뒤에 회사를 팔고 유언을 새로 쓸 예정이었습니다. 임다영을 딸로 올릴 서류도 준비해 뒀고요. 도현우가 10년 일한 회사는 남의 손에 넘어가고, 도현우가 받을 몫은 줄어들 참이었죠.'),
        me('그리고 지난달, 도현우는 회사 고문 변호사를 혼자 찾아가 물었습니다. 새어머니가 아버지를 해쳐서 유죄가 되면 상속은 어떻게 되느냐고요. 걱정하는 얼굴로.'),
        me('답은 「새어머니 몫까지 전부 아드님에게 간다」였습니다. 도현우에게는 죽은 아버지와, 살아서 범인이 되는 새어머니가 둘 다 필요했습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '도현우가 모녀에게 누명을 씌우려 했다는 증거를 제시하라',
      prompt: [say('kang', '…그림은 된다. 하지만 아직은 짐작으로 이어 붙인 그림이야. 그 친구가 모녀를 겨냥해서 직접 움직인 게 있나.')],
      accept: ['payphone'],
      near: {
        tip: [n('제보 내용은 강 팀장이 직접 들었다. 그 전화를 건 사람의 얼굴이 필요하다.')],
        lawyer: [n('도현우가 무엇을 노렸는지는 보여 준다. 하지만 물어본 것일 뿐이다. 도현우가 직접 움직인 흔적이 필요하다.')],
      },
      success: [
        me('팀장님이 받으신 익명 제보 전화. 발신지는 병원 로비 공중전화였습니다.'),
        me('그 시각 로비 CCTV입니다. 환자복을 입고 링거 걸이를 끈 채 수화기를 든 사람.'),
        n('강 팀장은 사진을 오래 봤다. 자기가 그 목소리를 믿고 사람을 체포했다는 것을 강 팀장도 알고 있었다.'),
        say('kang', '…펜 줘 봐.'),
        n('강 팀장은 서류의 이름 칸에 두 줄을 긋고, 그 위에 새 이름을 적었다.'),
      ],
    },
  ],
};

export const ENDINGS = {
  true: {
    title: '결합',
    lines: [
      n('병실에서 도현우는 창밖을 보고 있었다. 강 팀장과 내가 들어서자 넥타이를 고쳐 매듯 환자복 깃을 여몄다.'),
      me('도현우 씨. 토요일에서 일요일로 넘어가던 밤, 0시 14분부터 어디 계셨습니까.'),
      n('도현우는 한참 대답하지 않았다. 그러다 아주 조용히 말했다.'),
      say('hyunwoo', '제 친어머니가 병원에 누워 계실 때, 아버지는 그 여자와 저녁을 먹고 있었습니다. 저는 그걸 열아홉 살에 알았습니다.'),
      say('hyunwoo', '10년을 그 회사에서 일했습니다. 아버지는 회사를 팔고, 그 여자의 딸을 호적에 올리겠다고 했습니다. 저한테는 「넌 네 힘으로 살아라」 한마디였고요.'),
      say('hyunwoo', '그 여자는 아버지가 언제 어떻게 죽든 제일 먼저 의심받을 사람이었습니다. 맞고 살았으니까. 저는 그날을 조금 앞당겼을 뿐입니다.'),
      me('임다영 씨는요. 스물두 살입니다. 한 시간만 늦었어도 죽었습니다.'),
      n('도현우는 그 질문에는 끝내 대답하지 않았다.'),
      n('압수한 도현우의 차 트렁크에서 설비 공구 가방이 나왔다. 작업 장갑에 묻은 내열 실리콘은 해송동 연통의 것과 성분이 같았다. 가방 안쪽 주머니에는 나사 두 개가 들어 있었다.'),
      n('임서연의 수갑은 그날 오전에 풀렸다. 강 팀장이 직접 병실에 가서 풀었다.'),
      say('kang', '…제가 급했습니다. 죄송합니다.'),
      n('강 팀장은 112 신고 이력 세 건을 출력해서 자기 책상에 올려놓았다. 결재할 것만 올려놓는 그 책상에.'),
      n('퇴원하는 날, 임다영이 복도에서 나를 붙잡았다.'),
      say('dayoung', '형사님. 엄마는 왜 그 사람을 못 떠났을까요. 저는 아직도 모르겠어요.'),
      me('일산화탄소는 산소보다 200배 세게 붙는대요. 그래서 숨 쉴 자리를 다 차지한대요.'),
      me('그래도 맑은 공기를 마시면, 시간이 걸려도 결국 떨어진다고 했어요. 반씩, 또 반씩.'),
      n('임다영은 한참 생각하다가 고개를 끄덕였다. 엄마의 가방을 받아 들고, 엄마보다 반걸음 앞에서 걸어 나갔다.'),
      n('토요일. 사건이 없는 날, 사건이 없는 곳에서 윤은호를 만났다. 모항 해변의 겨울 바다다.'),
      say('eunho', '여기서 300미터만 가면 그 주차장이네요. 장소 선정이 별로였습니다.'),
      me('불난 자리도 가스 샌 자리도 아니니까 합격이에요.'),
      n('파도 소리에 말이 자꾸 끊겼다. 윤은호는 주머니에서 핫팩을 꺼내 한참 흔들더니 내 손에 쥐여 줬다. 그리고 그 손을 놓지 않았다.'),
      say('eunho', '헤모글로빈 얘기 말입니다. 붙잡기만 하는 게 아니라 놓아 줄 줄도 알아야 쓸모 있는 결합이라고, 제가 그랬잖아요.'),
      say('eunho', '저는 그걸 잘해 보고 싶습니다. …놓는 것 말고, 그 앞부분부터요.'),
      me('그게 무슨 말이에요.'),
      say('eunho', '과학적으로 설명하려면 시간이 좀 걸립니다, 지안 씨. 천천히 해도 됩니까.'),
      n('형사님이 아니라 지안 씨. 처음이었다.'),
      n('나는 손을 빼지 않았다.'),
    ],
    epilogue: '도현우는 아버지를 죽인 존속살해와 모녀에 대한 살인미수로 구속됐다. 임서연과 임다영은 그 집을 나왔다. 서지안은 토요일 저녁을 비워 두기 시작했다.',
  },
  bad: {
    title: '구속',
    lines: [
      n('말이 꼬였다. 강 팀장이 시계를 봤다.'),
      say('kang', '아홉 시다. 여기까지 하자, 서 경위. 영장 신청한다.'),
      n('임서연은 구속됐다. 딸의 면회는 일주일에 한 번, 10분이다.'),
      n('석 달 뒤 1심 판결이 났다. 상속인 명단에서 임서연의 이름이 지워졌다.'),
      n('그 무렵 정훈건설의 새 대표이사 취임 기사가 났다. 사진 속 얼굴은 반듯하게 넥타이를 매고 있었다.'),
    ],
    epilogue: '가장 쉬운 답으로 사건이 닫혔다. 하지만 단서는 아직 당신의 수첩에 남아 있다.',
    retry: 'deduce',
  },
};
